<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="The information that your customers will see once they've given feedback."/>
    <vx-card>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full my-2">
        <vs-input
            v-model="name"
            v-validate="'required|min:1|max:40'"
            data-vv-validate-on="blur"
            name="business name"
            label="Business Name"
            placeholder="e.g. Pat's Pizza"
            class="w-full"
            />
        <span class="text-danger block mt-2">{{ errors.first('business name') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full my-2">
        <vs-input
            v-model="email"
            v-validate="'required|email|min:3|max:100'"
            data-vv-validate-on="blur"
            name="email"
            label="Business email address"
            placeholder="your@email.com"
            class="w-full" />
          <span class="text-danger block mt-2">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full my-2">
        <div class="optionalwrap">
        <vs-input
          v-model="contact"
          label="Business contact number"
          v-validate="'min:3|max:20'"
          data-vv-validate-on="blur"
          name="contact number"
          placeholder="e.g. 555-372-4311"
          class="w-full"/>
          <span class="text-danger block mt-2">{{ errors.first('contact number') }}</span>
          </div>
      </div>
      <div class="vx-col md:w-1/2 w-full my-2">
        <div class="optionalwrap">
        <vs-input
          v-model="website"
          label="Business Website"
          v-validate="'min:3|max:50'"
          data-vv-validate-on="blur"
          name="website"
          placeholder="www.website.com"
          class="w-full"/>
          <span class="text-danger block mt-2">{{ errors.first('website') }}</span>
        </div>
      </div>
    </div>
    </vx-card>
    <savebutton submitText="Update" :accept="update" :goodToGo="formReady" />
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {
      setupData: false,
      name: '',
      email: '',
      website: '',
      contact: ''
    }
  },
  computed: {
    formReady() {
      if (this.setupData === JSON.stringify({
        name: this.name,
        contact: this.contact,
        email: this.email,
        website: this.website,
      })) {
        return false
      } else {
        if (this.errors.any()) return false
      }
      return true
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  methods: {
    initInitialData () {

      this.name = this.$store.state.dash.viewData.business.businessInfo.businessName

      this.contact = this.$store.state.dash.viewData.business.businessInfo.businessContact.localNumber

      this.website = this.$store.state.dash.viewData.business.businessInfo.webAddress

      this.email = this.$store.state.dash.viewData.business.businessInfo.businessEmail

      this.setupData = JSON.stringify({
        name: this.name,
        contact: this.contact,
        email: this.email,
        website: this.website,
      })
      
    },
    update () {
      this.$store.dispatch('dash/UPDATE_BUSINESS_INFORMATION', {
        businessInfo: {
          businessContact: {
            intlCode: '',
            localNumber: this.contact
          },
          businessEmail: this.email,
          businessName: this.name,
          webAddress: this.website
        }
      }).then(() => {
        this.$vs.notify({
          title: 'Update business information',
          text: 'Business information updated successfully',
          color: 'success',
          time: 5000,
          iconPack: 'feather',
          icon:'icon-check'})
      }).catch(() => {
        this.$vs.notify({
          title: 'Update business information',
          text:'Oops! Something went wrong, and we couldn\'t update your business information. Please try again, and reach out for support if it happens again.',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })
    }
  },
  created () {
    this.initInitialData()
  },
  watch: {
    '$store.state.dash.currentMultiLocationI' (v) {
      if (!this._inactive) {
        this.initInitialData()
      }
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
